<div class="main-container ac-table-page">
  <header class="page-header">
    <div class="title">
      <span class="title-text">Check-in / Check-out</span>
      <p class="small-title">{{ pageDescription }}</p>
    </div>

    <div class="header-actions">
      <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="loadLists()">Refresh</button>
    </div>
  </header>

  <form class="search-bar" (submit)="$event.preventDefault(); applyFilters()">
    <div class="each-div">
      <label class="drop-title" id="fd-utsav-label">Utsav</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select
          aria-labelledby="fd-utsav-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          [formControl]="fUtsav"
          (selectionChange)="applyFilters()"
        >
          <mat-option [value]="''">All Utsavs</mat-option>
          @for(utsav of utsavList; track utsav.utsavId){
          <mat-option [value]="utsav.utsavId">{{ utsav.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="each-div">
      <label class="drop-title" id="fd-property-label">Property</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select
          aria-labelledby="fd-property-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          [formControl]="fProperty"
          (selectionChange)="applyFilters()"
        >
          <mat-option [value]="''">All Properties</mat-option>
          @for(property of propertyList; track property.propertyId){
          <mat-option [value]="property.name">{{ property.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="each-div">
      <label class="drop-title" for="fd-family-code">Family Code</label>
      <input id="fd-family-code" type="text" class="text-box-active" placeholder="Family code"
        autocomplete="off" inputmode="numeric" [formControl]="fFamilyCode" (input)="applyFilters()" />
    </div>
    <div class="each-div">
      <label class="drop-title" for="fd-aadhaar">Aadhaar Number</label>
      <input id="fd-aadhaar" type="text" class="text-box-active" placeholder="Aadhaar number"
        autocomplete="off" inputmode="numeric" [formControl]="fAadhaar" (input)="applyFilters()" />
    </div>
    <div class="each-div">
      <label class="drop-title" for="fd-booking-id">Booking ID</label>
      <input id="fd-booking-id" type="text" class="text-box-active" placeholder="Booking id"
        autocomplete="off" inputmode="numeric" [formControl]="fBookingId" (input)="applyFilters()" />
    </div>
    <div class="each-div">
      <label class="drop-title" for="fd-room">Room Number</label>
      <input id="fd-room" type="text" class="text-box-active" placeholder="Room number"
        autocomplete="off" [formControl]="fRoom" (input)="applyFilters()" />
    </div>
    <div class="filter-actions">
      <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="resetFilters()">Reset</button>
    </div>
  </form>

  <div class="ac-tabs">
    <button
      type="button"
      class="ac-tab"
      [class.active]="activeTab === 'checkin'"
      (click)="setTab('checkin')"
    >
      Ready to check in ({{ toCheckIn.length }})
    </button>
    <button
      type="button"
      class="ac-tab"
      [class.active]="activeTab === 'staying'"
      (click)="setTab('staying')"
    >
      Currently staying ({{ residents.length }})
    </button>
  </div>

  @if(activeTab === 'checkin'){
  <section class="data-section" aria-labelledby="ready-to-check-in-title">
    <h2 class="section-title" id="ready-to-check-in-title">Ready to check in</h2>

    <div class="table-container ac-table-region" role="region" aria-label="Bookings ready to check in" tabindex="0" (scroll)="onListScroll($event)">
      <table
        class="table checkin-table ac-responsive-table ac-sortable-table"
        matSort
        [matSortDisableClear]="true"
        (matSortChange)="sortCheckIns($event)"
      >
      <thead class="table-head">
        <tr>
          <th scope="col" mat-sort-header="bookingId" data-mobile-sort>Booking ID</th>
          <th scope="col" mat-sort-header="familyCode" data-mobile-sort>Family Code</th>
          <th scope="col" mat-sort-header="bookedByName">Booked By</th>
          <th scope="col" mat-sort-header="accommodationType">Accommodation</th>
          <th scope="col" mat-sort-header="guestCount">Guests</th>
          <th scope="col" mat-sort-header="fromDate" data-mobile-sort>From</th>
          <th scope="col" mat-sort-header="toDate">To</th>
          <th scope="col" mat-sort-header="rooms">Rooms</th>
          <th scope="col">Guest Details</th>
          @if(canCheckIn){ <th scope="col" class="ac-actions-column">Action</th> }
        </tr>
      </thead>

      <tbody class="table-body">
        @for(booking of visibleToCheckIn; track booking.bookingId){
        <tr>
          <td data-label="Booking ID">{{ booking.bookingId }}</td>
          <td data-label="Family Code">{{ booking.familyCode }}</td>
          <td data-label="Booked By">{{ booking.bookedByName || '-' }}</td>
          <td data-label="Accommodation">{{ booking.accommodationType || '-' }}</td>
          <td data-label="Guests">{{ booking.guestCount }}</td>
          <td data-label="From">{{ booking.fromDate }}</td>
          <td data-label="To">{{ booking.toDate }}</td>
          <td data-label="Rooms">
            @if(roomsSummary(booking)){
            <button type="button" class="ac-secondary-small-btn guests-btn" (click)="viewRooms(booking)">
              {{ roomsSummary(booking) }}
            </button>
            } @else if(booking.rooms){
            <!-- older backend without the pairs: fall back to the joined lists -->
            {{ booking.properties }} — {{ booking.rooms }}
            } @else { - }
          </td>
          <td data-label="Guest Details">
            <button type="button" class="ac-secondary-small-btn guests-btn" (click)="viewGuests(booking)">
              View guests
            </button>
          </td>
          @if(canCheckIn){
          <td class="ac-actions-column" data-label="Action">
            <button type="button" class="ac-primary-btn row-action" [disabled]="isLoading" (click)="checkIn(booking)">
              Check In
            </button>
          </td>
          }
        </tr>
        }

        @if(hasLoaded && !isLoading && toCheckIn.length === 0){
        <tr class="ac-empty-table-row">
          <td [attr.colspan]="canCheckIn ? 10 : 9" class="empty-row">No bookings ready to check in</td>
        </tr>
        }
      </tbody>
      </table>
    </div>

    @if(checkInLimit < toCheckIn.length){
    <div class="load-more-row">
      <span class="muted">Showing {{ visibleToCheckIn.length }} of {{ toCheckIn.length }}</span>
      <button type="button" class="ac-secondary-small-btn load-more-btn" (click)="loadMore()">Load more</button>
    </div>
    }
  </section>
  }

  @if(activeTab === 'staying'){
  <section class="data-section" aria-labelledby="currently-staying-title">
    <h2 class="section-title" id="currently-staying-title">Currently staying</h2>

    <div class="table-container ac-table-region" role="region" aria-label="Guests currently staying" tabindex="0" (scroll)="onListScroll($event)">
      <table
        class="table checkout-table ac-responsive-table ac-sortable-table"
        matSort
        [matSortDisableClear]="true"
        (matSortChange)="sortResidents($event)"
      >
      <thead class="table-head">
        <tr>
          <th scope="col" mat-sort-header="bookingId" data-mobile-sort>Booking ID</th>
          <th scope="col" mat-sort-header="familyCode" data-mobile-sort>Family Code</th>
          <th scope="col" mat-sort-header="bookedByName">Booked By</th>
          <th scope="col" mat-sort-header="guestCount">Guests</th>
          <th scope="col" mat-sort-header="rooms">Rooms</th>
          <th scope="col">Guest Details</th>
          @if(canCheckOut){ <th scope="col" class="ac-actions-column">Action</th> }
        </tr>
      </thead>

      <tbody class="table-body">
        @for(resident of visibleResidents; track resident.bookingId){
        <tr>
          <td data-label="Booking ID">{{ resident.bookingId }}</td>
          <td data-label="Family Code">{{ resident.familyCode }}</td>
          <td data-label="Booked By">{{ resident.bookedByName || '-' }}</td>
          <td data-label="Guests">{{ resident.guestCount }}</td>
          <td data-label="Rooms">
            @if(roomsSummary(resident)){
            <button type="button" class="ac-secondary-small-btn guests-btn" (click)="viewRooms(resident)">
              {{ roomsSummary(resident) }}
            </button>
            } @else if(resident.rooms){
            <!-- older backend without the pairs: fall back to the joined lists -->
            {{ resident.properties }} — {{ resident.rooms }}
            } @else { - }
          </td>
          <td data-label="Guest Details">
            <button type="button" class="ac-secondary-small-btn guests-btn" (click)="viewGuests(resident)">
              View guests
            </button>
          </td>
          @if(canCheckOut){
          <td class="ac-actions-column" data-label="Action">
            <button type="button" class="ac-danger-btn row-action" [disabled]="isLoading" (click)="checkOut(resident.bookingId)">
              Check Out
            </button>
          </td>
          }
        </tr>
        }

        @if(hasLoaded && !isLoading && residents.length === 0){
        <tr class="ac-empty-table-row">
          <td [attr.colspan]="canCheckOut ? 7 : 6" class="empty-row">No guests currently staying</td>
        </tr>
        }
      </tbody>
      </table>
    </div>

    @if(stayingLimit < residents.length){
    <div class="load-more-row">
      <span class="muted">Showing {{ visibleResidents.length }} of {{ residents.length }}</span>
      <button type="button" class="ac-secondary-small-btn load-more-btn" (click)="loadMore()">Load more</button>
    </div>
    }
  </section>
  }
</div>

<app-loader [isLoading]="isLoading"></app-loader>
